import { PERSONAL_DATA } from '../constants';
import Item from '../Item';

const DataTreatment = () => (
  <>
    <h3 className="font-subtitle3 w-full text-left mb-16">
      Tratamiento de Datos personales
    </h3>

    <ul>
      {PERSONAL_DATA.map(({ paragraph, shouldParser }) => (
        <Item
          paragraph={paragraph}
          shouldParser={shouldParser}
          key={paragraph.slice(0, 7).replace(' ', '_')}
        />
      ))}
    </ul>
  </>
);

export default DataTreatment;
